import type React from 'react'

import type { BraintreePaymentItem } from '@/store/reducers/subscription'
import { Divider, PaymentItem } from './components'
import css from './styles.module.css'

interface Props {
  items: BraintreePaymentItem[]
  onDownload: (orderId: string) => void
}

export const PaymentsList: React.FC<Props> = ({ items, onDownload }) => {
  if (!items.length) {
    return null
  }

  return (
    <div className={css.payments_list}>
      <h3 className={css.header}>Payment history</h3>

      <ul className={css.list}>
        {items.map((item) => (
          <li className={css.li} key={item.orderId}>
            <PaymentItem onDownload={onDownload} item={item} />
            <Divider className={css.divider} />
          </li>
        ))}
      </ul>
    </div>
  )
}
